import BaseFileApi from './BaseFileApi'

class AdviserDataDumpApi extends BaseFileApi {
  get adviserDataDumpUrl () {
    return 'dataDump'
  }

  download () {
    return this.downloadFile(this.adviserDataDumpUrl)
  }

  upload (file) {
    return this.uploadFile(this.adviserDataDumpUrl, file)
  }

}
export default AdviserDataDumpApi
